const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/defs/trackingDefs.ts';
export const TrackingState = {
    AGREE: 'AGREE',
    DISAGREE: 'DISAGREE',
    INITIAL: 'INITIAL',
    NO_PERMISSION_AVAILABLE: 'NO_PERMISSION_AVAILABLE',
};

export const TrackingData = 'tracking_data';
